import React from 'react';
import styled from 'styled-components';
import { FiX, FiCheck, FiAlertTriangle, FiBell } from 'react-icons/fi';

const DrawerContainer = styled.div`
  position: fixed;
  top: 0;
  right: ${props => props.isOpen ? '0' : '-400px'};
  width: 400px;
  height: 100vh;
  background: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const DrawerHeader = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DrawerTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.125rem;
  font-weight: 500;
  color: #1e293b;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }
`;

const NotificationList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
`;

const NotificationItem = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  background: #f8fafc;
  margin-bottom: 0.75rem;
  transition: all 0.2s;

  &:hover {
    background: #f1f5f9;
  }
`;

const NotificationIcon = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  ${props => props.type === 'success' && `
    background: #dcfce7;
    color: #166534;
  `}
  
  ${props => props.type === 'error' && `
    background: #fee2e2;
    color: #991b1b;
  `}
`;

const NotificationContent = styled.div`
  flex: 1;
`;

const NotificationMessage = styled.div`
  color: #1e293b;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
`;

const NotificationTime = styled.div`
  color: #64748b;
  font-size: 0.75rem;
`;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #64748b;
  text-align: center;
  padding: 2rem;

  svg {
    width: 3rem;
    height: 3rem;
    margin-bottom: 1rem;
    opacity: 0.5;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  z-index: 999;
`;

const NotificationDrawer = ({ isOpen, onClose, notifications }) => {
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <>
      <Backdrop isOpen={isOpen} onClick={onClose} />
      <DrawerContainer isOpen={isOpen}>
        <DrawerHeader>
          <DrawerTitle>
            <FiBell size={20} />
            Notifications
          </DrawerTitle>
          <CloseButton onClick={onClose}>
            <FiX size={20} />
          </CloseButton>
        </DrawerHeader>
        
        <NotificationList>
          {notifications.length === 0 ? (
            <EmptyState>
              <FiBell />
              <div>No notifications yet</div>
            </EmptyState>
          ) : (
            notifications.map(notification => (
              <NotificationItem key={notification.id}>
                <NotificationIcon type={notification.type}>
                  {notification.type === 'success' ? (
                    <FiCheck size={16} />
                  ) : (
                    <FiAlertTriangle size={16} />
                  )}
                </NotificationIcon>
                <NotificationContent>
                  <NotificationMessage>{notification.message}</NotificationMessage>
                  <NotificationTime>{formatTime(notification.id)}</NotificationTime>
                </NotificationContent>
              </NotificationItem>
            ))
          )}
        </NotificationList>
      </DrawerContainer>
    </>
  );
};

export default NotificationDrawer; 